import Data from "../../models/Data";

const eng: Data = {
  service: {
    electrical: {
      title: "Electrical Systems",
      service: [
        "Inspect, Install, Repair, Electrical Systems, Lighting Systems, Houses, Buildings, Villages and Factories",
        "Design, System Installation, Switch Board, MDB, Distribution Boards, Control Cabinet",
        "Power System Services and General Electrical System Consulting",
        "Security System: CCTV, IP Camera Motion Sensor",
      ],
    },
    sanitary: {
      title: "Sanitary System",
      service: [
        "Design, Installation, Improvement of Water and Sanitation Systems",
        "Check the Quality and Thickness of the Pipe, Install the Overhaul Pump",
        "Installation of PPR, HDPE Water Pipes, Rainwater Drainage",
        "Ventilation System Improvement Services Inside the High Building",
      ],
    },
    machine: {
      title: "Machine Maintainance Services",
      service: [
        "Equipment and Repair Inverter, PLC, Controller Board, AC/DC Servo Drive etc.",
        "Modify Relay Monitoring, PLC program",
        "Repair Electrical, Mechanical, Pneumatic, Hydraulic Machines",
        "Preventive Maintenance of all types of Machines",
      ],
    },
    equipment: {
      title: "Electrical Equipment",
      service: [
        "Supply Industrial Parts and Sells a Full Range of Electrical Equipment",
        "Take Care of After-Sales Service",
      ],
    },
  },
  foundation: `9 Technical service co., ld was established in 2011. 
    Managed by experienced people Experience working for more than 20 years, 
    doing business about designing, installing, repairing, and fixing electrical systems of machines and industrial plants
    including service after installation. Analyzing the needs of every customer
    side by a team of experts and specialist technicians.
    Emphasis on detailed work, taking into account the quality of work that meets standards.
    Every work is inspected and tested before delivery.
    In order to meet the needs of customers to get the most out of both the limited time and the money invested.
    causing the company to gain trust from various agencies
    and many leading industrial factories.`,
  contact: {
    company: "9 Technical service co., ld",
    addressTopic: "Head Office: ",
    address: `55/293 Soi Prasert-Manukitch 42, Prasert-Manukitch Rd., Nawamin,
    Khet Bueng Kum, Bangkok 10230`,
    workshopTopic: `Workshop: `,
    workshop: `70/535 Prachaniwet 2 Soi Samakkee 58/20 Samakkee Rd., Tha Sai, Muang Nonthaburi, Nonthaburi
    11000`,
  },
};

export default eng;

